import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetInactivityTimeoutConfig = () => {
    const send = useGenericSend();

    return useCallback(() => send<Types.IGetInactivityTimeoutConfigRequest, Types.IGetInactivityTimeoutConfigResponse>({
        ID: 32942,
        responses: [32943, 32944],
        description: 'Get Inactivity Timeout Configuration',
        type: [10]
    }), [send]);
};
